import { useEffect, useState } from 'react'
import { useReselector } from '../../../utils/sharedHooks'
import { selectBookkeepingReportsById } from '@/selectors/bookkeepingReportsSelectors'
import { isoToUTCDateTime } from '@/utils/dateHelpers'
import { fetchTransactionCounts } from '@/actions/adminActions'
import { Card, Header, Loader } from 'semantic-ui-react'
import { useAppDispatch } from '@/utils/typeHelpers'

const TransactionCountsCard = ({
  loading,
  userId,
  reportId,
  transactionChangeCount,
}: {
  userId: string
  loading: boolean
  reportId: string
  transactionChangeCount: number
}) => {
  const dispatch = useAppDispatch()
  const [counts, setCounts] = useState<{
    pendingCount: number
    uncategorizedCount: number
    requestedClarificationCount: number
  }>()
  const report = useReselector(selectBookkeepingReportsById, reportId)

  useEffect(() => {
    const fetch = async () => {
      if (!report?.id) {
        return
      }

      const startDate = isoToUTCDateTime(report.startDate).startOf('month')
      const endDate = isoToUTCDateTime(report.endDate).endOf('month')
      const counts = await fetchTransactionCounts({
        userId,
        startDate,
        endDate,
      })(dispatch)
      if (counts) {
        setCounts(counts)
      }
    }

    fetch()
  }, [
    dispatch,
    report?.endDate,
    report?.id,
    report?.startDate,
    userId,
    transactionChangeCount,
  ])

  return (
    <Card fluid>
      <Card.Content>
        <Header as="h5">Transaction Counts</Header>

        {loading && <Loader active inline />}

        {!loading && counts && (
          <div>
            <p>
              <b>Needs Clarification: </b>
              {counts.requestedClarificationCount}
            </p>
            <p>
              <b>Pending: </b>
              {counts.pendingCount}
            </p>
            <p>
              <b>Uncategorized: </b>
              {counts.uncategorizedCount}
            </p>
          </div>
        )}
      </Card.Content>
    </Card>
  )
}

export default TransactionCountsCard
